class lqdStoreLocations extends elementorModules.frontend.handlers.Base {
  onInit(...args) {
    super.onInit(...args);
    this.initStoreLocations();
  }

  getDefaultSettings() {
    return {
      selectors: {
        main: '.ld-store-locations',
        mapElement: '[data-plugin-map]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');

    return {
      $main: this.$element.find(selectors.main),
      $mapElement: this.$element.find(selectors.mapElement),
    }
  }

  initStoreLocations() {
    if ('undefined' == typeof google || google == null) return;

    this.elements.$mapElement.liquidMap();
    this.elements.$main.liquidStoreLocations();
  }
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler(lqdStoreLocations, {$element});
};
